<template>
    <div class="custom-dropzone">
        <div
            class="custom-dropzone__card"
            :class="{ 'has-files': droppedFiles.length > 0, 'is-dragging': isDragging }"
            @dragover.prevent="isDragging = true"
            @dragleave.prevent="isDragging = false"
            @drop="handleDropEvent"
        >
            <div class="custom-dropzone__text">
                <v-icon size="40" class="mb-2" color="primary">mdi-cloud-upload</v-icon>
                <div class="text-subtitle-1 font-weight-medium">{{ $t("dropzone.drag-and-drop-text") }}</div>
                <div class="text-caption grey--text my-1">{{ $t("dropzone.or") }}</div>

                <v-btn color="primary" outlined class="mt-2" @click="selectFilesEvent">
                    <v-icon left>mdi-camera-plus</v-icon>
                    {{ $t("dropzone.select-files-text") }}
                </v-btn>

                <!-- Campo oculto configurado para aceptar fotos y PDFs -->
                <v-file-input
                    id="fileUpload"
                    hide-input
                    multiple
                    accept="image/*,application/pdf"
                    prepend-icon=""
                    class="d-none"
                    @change="selectFiles"
                ></v-file-input>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            droppedFiles: [],
            isDragging: false
        }
    },
    methods: {
        handleDropEvent(event) {
            event.preventDefault()
            this.isDragging = false
            const fileList = event.dataTransfer.files

            if (fileList && fileList.length) {
                this.processAndEmitFiles(Array.from(fileList))
            }
        },
        selectFilesEvent() {
            const fileUpload = document.getElementById('fileUpload')
            if (fileUpload) fileUpload.click()
        },
        selectFiles(fileList) {
            if (fileList && fileList.length) {
                this.processAndEmitFiles(Array.from(fileList))
            }
        },
        async processAndEmitFiles(files) {
            // Comprime solo las imágenes y deja intactos los PDF o documentos
            const processedFiles = await Promise.all(
                files.map(file => this.compressImageIfNeeded(file))
            )

            this.droppedFiles = [...this.droppedFiles, ...processedFiles]
            // Emite los archivos ya redimensionados
            this.$emit('files', processedFiles)
        },
        /**
         * Redimensiona la imagen a un máximo de 1920px (Full HD) y ajusta la calidad al 80%.
         * Un archivo de 10 MB de cámara pasa a pesar ~300 KB - 600 KB manteniéndose legible.
         */
        compressImageIfNeeded(file, maxWidth = 1920, maxHeight = 1080, quality = 0.8) {
            if (!file.type.startsWith('image/')) {
                return Promise.resolve(file)
            }

            return new Promise((resolve) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = (event) => {
                    const img = new Image()
                    img.src = event.target.result
                    img.onload = () => {
                        let width = img.width
                        let height = img.height

                        // Calcular dimensiones manteniendo la proporción
                        if (width > height) {
                            if (width > maxWidth) {
                                height = Math.round((height * maxWidth) / width)
                                width = maxWidth
                            }
                        } else {
                            if (height > maxHeight) {
                                width = Math.round((width * maxHeight) / height)
                                height = maxHeight
                            }
                        }

                        const canvas = document.createElement('canvas')
                        canvas.width = width
                        canvas.height = height

                        const ctx = canvas.getContext('2d')
                        ctx.drawImage(img, 0, 0, width, height)

                        canvas.toBlob(
                            (blob) => {
                                if (!blob) {
                                    resolve(file)
                                    return
                                }
                                const compressedFile = new File([blob], file.name, {
                                    type: 'image/jpeg',
                                    lastModified: Date.now()
                                })
                                resolve(compressedFile)
                            },
                            'image/jpeg',
                            quality
                        )
                    }
                    img.onerror = () => resolve(file)
                }
                reader.onerror = () => resolve(file)
            })
        }
    }
}
</script>

<style scoped>
.custom-dropzone__card {
    min-height: 200px;
    border: 2px dashed #ccc;
    border-radius: 8px;
    padding: 24px;
    text-align: center;
    background-color: #fafafa;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.custom-dropzone__card.is-dragging {
    border-color: #f36e21;
    background-color: rgba(243, 110, 33, 0.05);
}
</style>